import * as types from '../actions/actionTypes';
import initialState from './initialState';
import pull from 'lodash/pull';
import remove from 'lodash/remove';
import indexOf from 'lodash/indexOf';

export default function artistReducer(state = initialState.artistState, action) {
    let profiles;
    let profile;
    switch(action.type) {
        case types.GET_FEATURED_ARTISTS:
        //const copy = Object.assign({}, state, { featuredArtists: action.artists });
            return {
                ...state,
                featuredArtists: action.artists
            }
        case types.GET_PROFILE:
        //const copy = Object.assign({}, state, { featuredArtists: action.artists });
            profiles = [...state.profiles];
            profile = profiles.find(profile => profile.Username == action.profile.Username);
            
            if(profile == null) {
                profiles.push(action.profile);
            }
            else {
                const existingProfileIndex = indexOf(profiles, profile); 
                profiles.splice(existingProfileIndex, 1, action.profile);
            }
            return {
                ...state,
                profiles
            };
        case types.GET_PROFILE_STATUS: 
        {
            const profileLoadingStatus = [...state.profileLoadingStatus];
            const profileStatus = profileLoadingStatus.find(profileStatus => profileStatus.username == action.loadingStatus.username);
            
            if(profileStatus == null) {
                profileLoadingStatus.push(action.loadingStatus);
            }
            else {
                const existingProfileStatusIndex = indexOf(profileLoadingStatus, profileStatus); 
                profileLoadingStatus.splice(existingProfileStatusIndex, 1, action.loadingStatus);
            }
            return {
                ...state,
                profileLoadingStatus
            };
        }
        case types.GET_PROFILE_BIO:
            return {
                ...state,
                profiles: state.profiles.map(profile => {
                    if(profile.Username == action.profileBio.username){
                      return { ...profile, GetToKnowMe: action.profileBio.bio }
                    }
                    return profile;
                  })
            };
        case types.GET_PROFILE_BIO_STATUS:
            return {
                ...state,
                profiles: state.profiles.map(profile => {
                    if(profile.Username == action.loadingStatus.username){
                      return { ...profile, GetToKnowMeStatus: action.loadingStatus.status }
                    }
                    return profile
                  })
            };
        case types.GET_PROFILE_MUSIC:
            return {
                ...state,
                profiles: state.profiles.map(profile => {
                    if(profile.Username == action.profileMusic.username){
                      return { ...profile, Music: action.profileMusic.music }
                    }
                    return profile
                  })
            };
        case types.GET_PROFILE_MUSIC_STATUS:
            return {
                ...state,
                profiles: state.profiles.map(profile => {
                    if(profile.Username == action.loadingStatus.username){
                      return { ...profile, MusicStatus: action.loadingStatus.status }
                    }
                    return profile
                  })
            };
        case types.GET_PROFILE_VIDEOS:
            return {
                ...state,
                profiles: state.profiles.map(profile => {
                    if(profile.Username == action.profileVideos.username){
                      return { ...profile, Videos: action.profileVideos.videos }
                    }
                    return profile
                  })
            };
        case types.GET_PROFILE_VIDEOS_STATUS:
            return {
                ...state,
                profiles: state.profiles.map(profile => {
                    if(profile.Username == action.loadingStatus.username){
                      return { ...profile, VideosStatus: action.loadingStatus.status }
                    }
                    return profile
                  })
            };
        case types.GET_PROFILE_GIGS:
            return {
                ...state,
                profiles: state.profiles.map(profile => {
                    if(profile.Username == action.profileGigs.username){
                      return { ...profile, Gigs: action.profileGigs.gigs }
                    }
                    return profile
                  })
            };
        case types.GET_PROFILE_GIGS_STATUS:
            return {
                ...state,
                profiles: state.profiles.map(profile => {
                    if(profile.Username == action.loadingStatus.username){
                      return { ...profile, GigsStatus: action.loadingStatus.status }
                    }
                    return profile
                  })
            };
        case types.GET_PROFILE_BUYOPTIONS:
            return {
                ...state,
                profiles: state.profiles.map(profile => {
                    if(profile.Username == action.profileBuyOptions.username){
                      return { ...profile, BuyOptions: action.profileBuyOptions.buyOptions }
                    }
                    return profile
                  })
            };
        case types.GET_PROFILE_BUYOPTIONS_STATUS:
            return {
                ...state,
                profiles: state.profiles.map(profile => {
                    if(profile.Username == action.loadingStatus.username){
                      return { ...profile, BuyOptionsStatus: action.loadingStatus.status }
                    }
                    return profile
                  })
            };
        case types.GET_PROFILE_COMMENTS:
            return {
                ...state,
                profiles: state.profiles.map(profile => {
                    if(profile.Username == action.profileComments.username){
                      return { ...profile, Comments: action.profileComments.comments }
                    }
                    return profile
                  })
            };
        case types.GET_PROFILE_COMMENTS_STATUS:
            return {
                ...state,
                profiles: state.profiles.map(profile => {
                    if(profile.Username == action.loadingStatus.username){
                      return { ...profile, CommentsStatus: action.loadingStatus.status }
                    }
                    return profile
                  })
            };
        case types.GET_PROFILE_CONVERSATION:
            return {
                ...state,
                profiles: state.profiles.map(profile => {
                    if(profile.Username == action.profileConversation.username){
                      return { ...profile, Conversation: action.profileConversation.conversation }
                    }
                    return profile
                  })
            };
        case types.GET_PROFILE_CONVERSATION_STATUS:
            return {
                ...state,
                profiles: state.profiles.map(profile => {
                    if(profile.Username == action.loadingStatus.username){
                      return { ...profile, ConversationStatus: action.loadingStatus.status }
                    }
                    return profile
                  })
            };
        case types.GET_PROFILE_ADDRESS:
            return {
                ...state,
                profiles: state.profiles.map(profile => {
                    if(profile.Username == action.profileAddress.username){
                      return { ...profile, Address: action.profileAddress.address }
                    }
                    return profile
                  })
            };
        case types.GET_PROFILE_ADDRESS_STATUS:
            return {
                ...state,
                profiles: state.profiles.map(profile => {
                    if(profile.Username == action.loadingStatus.username){
                      return { ...profile, AddressStatus: action.loadingStatus.status }
                    }
                    return profile
                  })
            };
        case types.GET_PROFILE_CONNECTIONS_INBOUND:
            return {
                ...state,
                profiles: state.profiles.map(profile => {
                    if(profile.Username == action.profileConnections.username){
                      return { ...profile, ConnectionsInbound: action.profileConnections.connections }
                    }
                    return profile
                  })
            };
        case types.GET_PROFILE_CONNECTIONS_INBOUND_STATUS:
            return {
                ...state,
                profiles: state.profiles.map(profile => {
                    if(profile.Username == action.loadingStatus.username){
                      return { ...profile, ConnectionsInboundStatus: action.loadingStatus.status }
                    }
                    return profile
                  })
            };
        case types.GET_PROFILE_CONNECTIONS_OUTBOUND:
            return {
                ...state,
                profiles: state.profiles.map(profile => {
                    if(profile.Username == action.profileConnections.username){
                      return { ...profile, ConnectionsOutbound: action.profileConnections.connections }
                    }
                    return profile
                  })
            };
        case types.GET_PROFILE_CONNECTIONS_OUTBOUND_STATUS:
            return {
                ...state,
                profiles: state.profiles.map(profile => {
                    if(profile.Username == action.loadingStatus.username){
                      return { ...profile, ConnectionsOutboundStatus: action.loadingStatus.status }
                    }
                    return profile
                  })
            };
        case types.ADD_CONNECTION:
        {
            const socketProfileID = action.connection.socketProfileID;
            const plugUsername = action.connection.plugUsername;
            return {
                ...state,
                profiles: state.profiles.map(profile => {
                    if(profile.RoleID === socketProfileID){
                      return { ...profile, PluggedIn: profile.PluggedIn + 1 }
                    }
                    else if(profile.Username === plugUsername) {
                        return { ...profile, PluggedInto: profile.PluggedInto + 1 }
                    }
                    return profile
                  })
            };
        }
        case types.DELETE_CONNECTION:
        {
            const socketProfileID = action.connection.socketProfileID;
            const plugUsername = action.connection.plugUsername;
            return {
                ...state,
                profiles: state.profiles.map(profile => {
                    if(profile.RoleID == socketProfileID){
                      return { ...profile, PluggedIn: profile.PluggedIn - 1 }
                    }
                    else if(profile.Username === plugUsername) {
                        return { ...profile, PluggedInto: profile.PluggedInto - 1 }
                    }
                    return profile
                  })
            };
        }
        case types.UPDATE_ROLE_RATING:
        {
            const roleID = action.roleRating.id;
            const rating = action.roleRating.rating; 
            return {
                ...state,
                profiles: state.profiles.map(profile => {
                    if(profile.RoleID == roleID){
                      return { ...profile, Rating: rating }
                    }
                    return profile;
                })
            };
        }
        case types.SET_PROFILE_BROWSE_ROLETYPE:
        {
            return {
                ...state,
                browse: { ...state.browse, roleType: action.roleType}
            };
        }
        case types.SET_PROFILE_BROWSE_TAB:
        {
            return {
                ...state,
                browse: { ...state.browse, selectedTab: action.selectedTab}
            };
        }
        case types.SET_PROFILE_KEYWORD:
        {
            return {
                ...state,
                browse: { ...state.browse, keyword: action.keyword}
            };
        }
        case types.CLEAR_PROFILE_KEYWORD:
        {
            return {
                ...state,
                browse: { ...state.browse, keyword: ''}
            };
        }
        case types.BROWSE_PROFILES_STATUS: 
        {
            return {
                ...state,
                browse: { ...state.browse, loadingStatus: action.loadingStatus}
            };
        }
        case types.SET_PROFILE_BROWSE_RESULTS:
        {
            const roleTypesMatch = state.browse.results.roleType.type === action.results.roleType.type;
            const nextPage = state.browse.results.lastPage + 1 === action.results.lastPage;
            const items = roleTypesMatch && nextPage ? [...state.browse.results.items].concat(action.results.items) : action.results.items;
            const results = {...action.results, items};
            return {
                ...state,
                browse: { ...state.browse, results}
            };
        }
        case types.CLEAR_PROFILE_BROWSE_RESULTS:
        {
            return {
                ...state,
                browse: { ...state.browse, loadingStatus: null, results: initialState.artistState.browse.results}
            };
        }
        case types.CLEAR_PROFILE_SEARCH_CRITERIA:
        {
            return {
                ...state,
                browse: { ...state.browse, searchCriteria: initialState.artistState.browse.searchCriteria, keyword: initialState.artistState.browse.keyword}
            };
        }
        case types.SET_PROFILE_SEARCH_ERROR:
        {
            return {
                ...state,
                browse: { ...state.browse, searchError: action.error.message}
            };
        }
        case types.CLEAR_PROFILE_SEARCH_ERROR:
        {
            return {
                ...state,
                browse: { ...state.browse, searchError: null}
            };
        }
        case types.SET_PROFILE_BROWSE_ERROR:
        {
            return {
                ...state,
                browse: { ...state.browse, browseError: action.error.message}
            };
        }
        case types.CLEAR_PROFILE_BROWSE_ERROR:
        {
            return {
                ...state,
                browse: { ...state.browse, browseError: null}
            };
        }
        case types.SET_PROFILE_BROWSE_SORT:
        {
            return {
                ...state,
                browse: { 
                    ...state.browse, 
                    searchCriteria: {
                        ...state.browse.searchCriteria,
                        sort: action.sortField
                    }
                }
            };
        }
        case types.SET_PROFILE_BROWSE_CAPACITY:
        {
            return {
                ...state,
                browse: { 
                    ...state.browse, 
                    searchCriteria: {
                        ...state.browse.searchCriteria,
                        selectedCapacity: action.capacity
                    }
                }
            };
        }
        case types.SET_PROFILE_BROWSE_ADD_GENRE:
        {
            const selectedGenres = [...state.browse.searchCriteria.selectedGenres];
            selectedGenres.push(action.genre);
            return {
                ...state,
                browse: { 
                    ...state.browse, 
                    searchCriteria: {
                        ...state.browse.searchCriteria,
                        selectedGenres
                    }
                }
            };
        }
        case types.SET_PROFILE_BROWSE_REMOVE_GENRE:
        {
            const selectedGenres = [...state.browse.searchCriteria.selectedGenres];
            pull(selectedGenres, action.genre);
            return {
                ...state,
                browse: { 
                    ...state.browse, 
                    searchCriteria: {
                        ...state.browse.searchCriteria,
                        selectedGenres
                    }
                }
            };
        }
        case types.SET_PROFILE_BROWSE_CLEAR_GENRES:
        {
            return {
                ...state,
                browse: { 
                    ...state.browse, 
                    searchCriteria: {
                        ...state.browse.searchCriteria,
                        selectedGenres: []
                    }
                }
            };
        }
        case types.SET_PROFILE_BROWSE_ASSOCIATIONS:
        {           
            return {
                ...state,
                browse: { 
                    ...state.browse, 
                    searchCriteria: {
                        ...state.browse.searchCriteria,
                        selectedAssociations: action.associations
                    }
                }
            };
        }        
        case types.SET_PROFILE_BROWSE_DISTANCE:
        {
            return {
                ...state,
                browse: { 
                    ...state.browse, 
                    searchCriteria: {
                        ...state.browse.searchCriteria,
                        distance: action.distance
                    }
                }
            };
        }
        case types.SET_PROFILE_BROWSE_DISTANCE_UNIT:
        {
            return {
                ...state,
                browse: { 
                    ...state.browse, 
                    searchCriteria: {
                        ...state.browse.searchCriteria,
                        distanceUnit: action.unit
                    }
                }
            };
        }
        case types.SET_PROFILE_BROWSE_LOCATION:
        {
            return {
                ...state,
                browse: { 
                    ...state.browse, 
                    searchCriteria: {
                        ...state.browse.searchCriteria,
                        location: action.location
                    }
                }
            };
        }
        case types.SET_PROFILE_BROWSE_INSTRUMENT:
        {        
            return {
                ...state,
                browse: { 
                    ...state.browse, 
                    searchCriteria: {
                        ...state.browse.searchCriteria,
                        instrument: action.instrument
                    }
                }
            };
        }
        case types.SET_PROFILE_BROWSE_EXPERTISE:
        {
            return {
                ...state,
                browse: { 
                    ...state.browse, 
                    searchCriteria: {
                        ...state.browse.searchCriteria,
                        expertise: action.expertise
                    }
                }
            };
        }        
        case types.SET_CREATE_PROFILE_ERROR:
        {
            return {
                ...state,
                createProfileError: action.error.message
            };
        }
        case types.CLEAR_CREATE_PROFILE_ERROR:
        {
            return {
                ...state,
                createProfileError: null
            };
        }
        case types.UPDATE_PROFILE_SUCCESS:
        {
            //remove the profile from the list so we can reload it if we visit the profile page again
            const profiles = [...state.profiles];
            remove(profiles, p => p.RoleID === action.profile.ID);
            return {
                ...state,
                profiles
            };
        }
        case types.PROFILE_IMAGES_UPDATED:
        {
            //if we have the profile loaded, update the images
            return {
                ...state,
                profiles: state.profiles.map(profile => {
                    if(profile.RoleID == action.profile.id){
                      return { ...profile, Images: action.profile.images }
                    }
                    return profile
                  })
            };
        }
        case types.CLEAR_PROFILE_TRACKS:
        {
            //if we have the profile loaded, clear the images to force a reload
            return {
                ...state,
                profiles: state.profiles.map(profile => {
                    if(profile.RoleID == action.profile.id){
                      return { ...profile, Music: null, MusicStatus: null }
                    }
                    return profile
                  })
            };
        }
        case types.CLEAR_PROFILE_VIDEOS:
        {
            //if we have the profile loaded, clear the images to force a reload
            return {
                ...state,
                profiles: state.profiles.map(profile => {
                    if(profile.RoleID == action.profile.id){
                      return { ...profile, Videos: null, VideosStatus: null }
                    }
                    return profile
                  })
            };
        }
        case types.CLEAR_PROFILE_GIGS:
        {
            //if we have the profile loaded, clear the gigs to force a reload
            return {
                ...state,
                profiles: state.profiles.map(profile => {
                    if(profile.RoleID == action.profile.id){
                      return { ...profile, Gigs: null, GigsStatus: null }
                    }
                    return profile
                  })
            };
        }
        case types.CLEAR_PROFILE_BUY_OPTIONS:
        {
            //if we have the profile loaded, clear the buy options to force a reload
            return {
                ...state,
                profiles: state.profiles.map(profile => {
                    if(profile.RoleID == action.profile.id){
                      return { ...profile, BuyOptions: null, BuyOptionsStatus: null }
                    }
                    return profile
                  })
            };
        }
        case types.CLEAR_PROFILE_ADDRESS:
        {
            //if we have the profile loaded, clear the address to force a reload
            return {
                ...state,
                profiles: state.profiles.map(profile => {
                    if(profile.RoleID == action.profile.id){
                      return { ...profile, Address: null, AddressStatus: null }
                    }
                    return profile
                  })
            };
        }
        case types.UPDATE_TRACK_RATING:
        {
            const trackID = action.trackRating.id;
            const rating = action.trackRating.rating; 
            const trackProfileID = action.trackRating.trackProfileID;
            return {
                ...state,
                profiles: state.profiles.map(profile => {
                    if(profile.RoleID == trackProfileID && profile.Music && profile.Music.length) {
                        const music = profile.Music.map(track => {
                            if(track.ID === trackID) {
                                return { ...track, Rating: rating };
                            }
                            return track;
                        });
                      return { ...profile, Music: music }
                    }
                    return profile
                  })
            };
        }
        case types.UPDATE_VIDEO_RATING:
        {
            const videoID = action.videoRating.id;
            const rating = action.videoRating.rating; 
            const videoProfileID = action.videoRating.videoProfileID;
            return {
                ...state,
                profiles: state.profiles.map(profile => {
                    if(profile.RoleID == videoProfileID && profile.Videos && profile.Videos.length) {
                        const videos = profile.Videos.map(video => {
                            if(video.ID === videoID) {
                                return { ...video, Rating: rating };
                            }
                            return video;
                        });
                      return { ...profile, Videos: videos }
                    }
                    return profile
                  })
            };
        }
        case types.LOGOUT:
        {
            return {
                ...state,
                createProfileError: null,
                profiles: []
            }; 
        }
        /*let copy = [...state,
            Object.assign({}, action.artists)
        ];*/
        //debugger;
       /*
       {
            ...state,
            myPosts: {
                ...state.myPosts,
                isPending: true
            }
            }
       */
       // return copy;
        //return action.artists;
        /*explodes the array and adds the new item to create a new reference*/
           
        default:
            return state;
    }
}